import { render, staticRenderFns } from "./PointsConfiguration.vue?vue&type=template&id=0cceba54&scoped=true"
import script from "./PointsConfiguration.vue?vue&type=script&lang=js"
export * from "./PointsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PointsConfiguration.vue?vue&type=style&index=0&id=0cceba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cceba54",
  null
  
)

export default component.exports